import tinymce from "tinymce";
import { Message } from "element-ui";
// import $ from "jquery";
import { SendPostData } from "../../../assets/script/model/index";

import contents from "../../../store/content";
import config from "../../script/config";
//1.引入vue
import Vue from "vue";
import Cookies from "js-cookie";

//2.新创建一个vue实例
let v = new Vue();

const SendMessage = sendData => {
  let wycBox = window._5118_Wyc_Box;
  wycBox.contentWindow.postMessage(sendData, "*");
};

const setWycContent = (content, txt) => {
  let sendData = new SendPostData();
  sendData.btn = "use";
  let sendType = "after";
  sendData.data = { txt: content, insertSeat: sendType };
  SendMessage(sendData);

  Message({
    message: txt,
    showClose: true,
    type: "success"
  });
};

const setWycAbstract = (content, txt) => {
  let sendData = new SendPostData();
  sendData.btn = "use";
  let sendType = "before";
  sendData.data = { txt: content, insertSeat: sendType };
  SendMessage(sendData);

  Message({
    message: txt,
    showClose: true,
    type: "success"
  });
};

const setInnerStyle = (content, txt) => {
  let newHtml =
    //margin: 0px auto; width: 100%; 让样式居中
    "<br /><section class='parentStyle' style='margin: 0px auto; width: 100%;'><p style='display: block;'/>" +
    content +
    "<p style='display: block;'/></section><br />&nbsp;";

  // this.deactiveItem(tinymce.activeEditor.getDoc());

  tinymce.activeEditor.insertContent(newHtml);
  tinymce.activeEditor.focus();

  Message({
    message: txt,
    showClose: true,
    type: "success"
  });
};

const setInnerPicture = (content, txt) => {
  let newHtml = `<p style="margin-top: 10px;margin-bottom: 10px;text-align: center;"><img src="${content}"></p>`;

  tinymce.activeEditor.insertContent(newHtml);
  tinymce.activeEditor.focus();

  Message({
    message: txt,
    showClose: true,
    type: "success"
  });
};

const setInnerTxt = (content, txt) => {
  // content = content.replace(/<section[^>]*?>/gi, "<p>");
  // content = content.replace(/<\/section>/gi, "</p>");
  // content = content.replace(/<(?!p).*?>/gi, "");
  // content = content.replace(/<p>(?:\s*&nbsp;\s*)*?<\/p>/gi, "");
  // content = content.replace(/<p[^>]*?>/gi, "<p>");
  content = content.replace(
    content,
    '<p><span class="flicker">' + content + "</span></p>"
  );
  tinymce.activeEditor.insertContent(content);
  tinymce.activeEditor.focus();

  Message({
    message: txt,
    showClose: true,
    type: "success"
  });

  // setTimeout(() => {
  //   let flicker = document.querySelector(".flicker");
  //   flicker.classList.remove("flicker");
  // }, 1000);
};

const setAllInnerTxt = (content, txt) => {
  content = content.replace(
    /^[\S|\s]*?<div>\s*<div[^>]*?>([\S|\s]*?)<\/div>(?:<\/p>\s*<\/p>)?$/gi,
    "$1"
  );
  content = content.replace(
    /<div class="._5ce-wx-style"[^>]*?>\s*<div class="rich_media_content" id="js_content">\s*([\S|\s]*?)\s*<\/div>\s*<\/div>$/g,
    "$1"
  );
  tinymce.activeEditor.insertContent(content);
  tinymce.activeEditor.focus();
  v.$nextTick(() => {
    try {
      let imgDomList = document
        .getElementsByClassName("mce-content-body")[0]
        .getElementsByTagName("img");
      for (let img of imgDomList) {
        if (img.dataset["src"]) {
          img.src = img.dataset["src"].replace(/http:/g, "https:");
        }
        img.dataset["mceSrc"] = img.src.replace(/http:/g, "https:");
        // img.style.padding = "10px 0";
        let imgs = new Image();
        imgs.src = img.dataset["src"];
        imgs.width > 500
          ? (img.style.width = "100%")
          : (img.style.width = "auto");
      }
      tinymce.activeEditor.insertContent("");
      tinymce.activeEditor.focus();
    } catch (e) {
      console.log(e);
    }
  });

  Message({
    message: txt,
    showClose: true,
    type: "success"
  });
};

const setAllInnerNoDataTxt = (content, txt) => {
  // content = content.replace(/<section[^>]*?>/gi, "<p>");
  // content = content.replace(/<\/section>/gi, "</p>");
  // content = content.replace(/<(?!p).*?>/gi, "");
  // content = content.replace(/<p>(?:\s*&nbsp;\s*)*?<\/p>/gi, "");
  // content = content.replace(/<p[^>]*?>/gi, "<p>");
  tinymce.activeEditor.insertContent(content);
  tinymce.activeEditor.focus();
  v.$nextTick(() => {
    try {
      let imgDomList = document
        .getElementsByClassName("mce-content-body")[0]
        .getElementsByTagName("img");
      for (let img of imgDomList) {
        let imgs = new Image();
        imgs.src = img.src;
        img.dataset["mceSrc"] = img.src;
        imgs.width > 500
          ? (img.style.width = "100%")
          : (img.style.width = "auto");
      }
      tinymce.activeEditor.insertContent("");
      tinymce.activeEditor.focus();
    } catch (e) {
      console.log(e);
    }
  });
  Message({
    message: txt,
    showClose: true,
    type: "success"
  });
};

const setAllContent = (content, txt) => {
  // content = content.replace(/<section[^>]*?>/gi, "<p>");
  // content = content.replace(/<\/section>/gi, "</p>");
  // content = content.replace(/<(?!p).*?>/gi, "");
  // content = content.replace(/<p>(?:\s*&nbsp;\s*)*?<\/p>/gi, "");
  // content = content.replace(/<p[^>]*?>/gi, "<p>");

  tinymce.activeEditor.setContent(content);
  tinymce.activeEditor.focus();

  v.$nextTick(() => {
    try {
      let imgDomList = document
        .getElementsByClassName("mce-content-body")[0]
        .getElementsByTagName("img");
      for (let img of imgDomList) {
        if (img.dataset["src"]) {
          img.src = img.dataset["src"].replace(/http:/g, "https:");
        }
        img.dataset["mceSrc"] = img.src.replace(/http:/g, "https:");
        // img.style.padding = "10px 0";
        let imgs = new Image();
        imgs.src = img.dataset["src"];
        imgs.width > 500
          ? (img.style.width = "100%")
          : (img.style.width = "auto");
      }
      tinymce.activeEditor.insertContent("");
      tinymce.activeEditor.focus();
    } catch (e) {
      console.log(e);
    }
  });

  if (txt !== "") {
    Message({
      message: txt,
      showClose: true,
      type: "success"
    });
  }
};

const showLoginMessage = (isshwo, message, btnName = "") => {
  contents.state.showLoginDialogs = isshwo;
  contents.state.showMessage = message;
  contents.state.showBtn = btnName;
};

const showPrompt = (isshwo, message) => {
  contents.state.showPrompt = isshwo;
  contents.state.showMessage = message;
};

const showUpgrade = (isshwo, message) => {
  contents.state.showUpgrade = isshwo;
  contents.state.showUpgradeMessage = message;
};

const getQueryString = (name, Referer) => {
  let reg = new RegExp("(^|&|\\?)" + name + "=([^&]*)(&|$)");
  let r = Referer.match(reg);
  if (r != null) return unescape(r[2]);
  return "";
};
const getAllQueryString = url => {
  let reg = new RegExp("\\?([\\S|\\s]*?)$");
  let r = url.match(reg);
  if (r != null) return unescape(r[1]);
  return "";
};

const addReff = () => {
  let getReff = document.referrer;
  let getNowUrl = window.location.href;
  let t = getQueryString("t", getNowUrl) || "";
  let allString = getAllQueryString(getNowUrl) || "";
  let reffParam = {
    questionParam: allString,
    TParam: t,
    Referer: getReff
  };
  if (getNowUrl.indexOf("5118.com") !== -1) {
    let exp = new Date();
    exp.setTime(exp.getTime() + 99999 * 24 * 60 * 60 * 1000);
    Cookies.set(".5ce.referer", JSON.stringify(reffParam), {
      expires: exp,
      domain: ".5118.com"
    });
  } else {
    // console.log("获取到reff:" + getReff + " T:" + t + " all:" + allString);
    let exp = new Date();
    exp.setTime(exp.getTime() + 99999 * 24 * 60 * 60 * 1000);
    Cookies.set(".5ce.referer", JSON.stringify(reffParam), {
      expires: exp,
      domain: config.cookieDomain
    });
  }
};
const appendZero = obj => {
  if (obj < 10) {
    return "0" + obj;
  } else {
    return obj;
  }
};
const getDayTime = () => {
  let date1 = new Date();
  let year = date1.getFullYear();
  let month = date1.getMonth() + 1;
  let day = date1.getDate();
  return appendZero(year) + "-" + appendZero(month) + "-" + appendZero(day);
};
const setUserCookies = (name, values, days = 30) => {
  let getUrl = window.location.href;
  let exp = new Date();
  exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
  let setDomain = "5ce.com";
  if (getUrl.indexOf("5118.com") !== -1) {
    setDomain = "5118.com";
  }
  if (getUrl.indexOf("5ce.com") !== -1) {
    setDomain = "5ce.com";
  }
  if (getUrl.indexOf("localhost") !== -1) {
    setDomain = "localhost";
  }
  Cookies.set(name, JSON.stringify(values), {
    expires: exp,
    domain: setDomain
  });
};
const setGiftCookies = (takeId, type = 0) => {
  let getUrl = window.location.href;
  let exp = new Date();
  let user = {
    isTake: takeId,
    showBox: getDayTime(),
    isType: type
  };
  exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);
  let setDomain = "5ce.com";
  if (getUrl.indexOf("5118.com") !== -1) {
    setDomain = "5118.com";
  }
  if (getUrl.indexOf("5ce.com") !== -1) {
    setDomain = "5ce.com";
  }
  if (getUrl.indexOf("localhost") !== -1) {
    setDomain = "localhost";
  }
  Cookies.set("UserGift", JSON.stringify(user), {
    expires: exp,
    domain: setDomain
  });
};
export default {
  setInnerTxt,
  setAllContent,
  setWycContent,
  setWycAbstract,
  setAllInnerTxt,
  setInnerStyle,
  setAllInnerNoDataTxt,
  setInnerPicture,
  showLoginMessage,
  showPrompt,
  showUpgrade,
  addReff,
  setGiftCookies,
  getDayTime,
  setUserCookies
};
